/*
 * The video engine (Mediabunny, about half a megabyte) is loaded only when a video is actually read or written,
 * so opening the app for a design stays as fast as before. A failed load says why and can be tried again.
 */

let convert: Promise<typeof import('./convert')> | null = null;
let exporter: Promise<typeof import('./exporter')> | null = null;

const why = (e: unknown) => 'โหลดตัวจัดการวิดีโอไม่สำเร็จ (ลองตรวจอินเทอร์เน็ตแล้วลองใหม่): ' + (e instanceof Error ? e.message : String(e));

export function videoConvert(): Promise<typeof import('./convert')> {
  convert ??= import('./convert').catch(e => { convert = null; throw new Error(why(e)); });
  return convert;
}

export function videoExporter(): Promise<typeof import('./exporter')> {
  exporter ??= import('./exporter').catch(e => { exporter = null; throw new Error(why(e)); });
  return exporter;
}
